import { AnimatePresence, motion } from "framer-motion"
import moment from "moment"
import { Image } from "@components/anti/Image"
import { convertJson, extractMeta, filterReportData } from "src/mixins"
import { translations } from "src/helper/translations"
import InvestorsPdfItem from "../investors-area-governance/investors-pdf-item"

function OurCommitmentSustanModal({
  showModal,
  setShowModal,
  locale,
  reports,
  loadingReports,
  errorReports,
}) {
  return (
    <AnimatePresence mode="wait">
      {showModal ? (
        <motion.div
          key={showModal}
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 50, opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="modal-full modal-our-commitment-sustain"
        >
          <div
            className="close-btn"
            role="presentation"
            onClick={() => {
              document.body.classList.remove("no-scroll")
              setShowModal(false)
            }}
          >
            <Image
              fill
              src="/img/icon/img_icon-close-white.svg"
              alt="ic-close"
              className="ic-close"
            />
          </div>
          <div className="bg-top" />
          <div className="modal-our-commitment-sustain__top">
            <h1 className="modal-our-commitment-sustain__title">
              {translations[`sustainability_report_${locale}`]}
            </h1>
          </div>
          <div className="modal-our-commitment-sustain__bottom">
            <div className="row row-reports">
              {loadingReports ? (
                <div className="loading-dots-wrapper">
                  <h3 className="loading-dots">Loading</h3>
                </div>
              ) : errorReports ? (
                <p>Error: {errorReports.message}</p>
              ) : filterReportData(reports, locale)?.length ? (
                filterReportData(reports, locale).map((item, i) => {
                  const meta = extractMeta(item.meta, "report")
                  return (
                    <div
                      className="col-md-6 col-xl-4"
                      key={`prospectus-item-${i}`}
                    >
                      <InvestorsPdfItem
                        title={item[`title_${locale}`]}
                        date={moment(item.published_at).format("DD MMMM YYYY")}
                        linkPdf={`${process.env.STORAGE_URL}/${
                          convertJson(meta?.file_id)?.path
                        }`}
                        key={`prospectus-item-${i}`}
                      />
                    </div>
                  )
                })
              ) : null}
            </div>
          </div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  )
}

export default OurCommitmentSustanModal
